var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "z-contact-card",
      class: { "z-contact-card--horizontal": _vm.horizontal },
    },
    [
      _vm.title || _vm.subtitle
        ? _c("div", { staticClass: "z-contact-card__head" }, [
            _vm.photo
              ? _c("picture", { staticClass: "z-contact-card__pic" }, [
                  _c("img", { attrs: { src: _vm.photo } }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "z-contact-card__text" }, [
              _vm.title || _vm.$slots["title"]
                ? _c(
                    "div",
                    { staticClass: "z-contact-card__title" },
                    [
                      _vm.link
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.link,
                                title: _vm.title ? _vm.title : "",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.title) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.title) },
                          }),
                      _vm._v(" "),
                      _vm._t("title"),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.subtitle || _vm.$slots["subtitle"]
                ? _c(
                    "div",
                    {
                      staticClass: "z-contact-card__subtitle",
                      domProps: { innerHTML: _vm._s(_vm.subtitle) },
                    },
                    [_vm._t("subtitle")],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "z-contact-card__communications-list" },
        [
          _vm.address
            ? [
                _vm._l(_vm.address, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: "address-" + index,
                        staticClass: "communication-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "communication-item__title" },
                          [
                            index === 0
                              ? _c("span", [_vm._v(_vm._s(_vm.text.address))])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "communication-item__link" },
                          [
                            _c("z-icon", {
                              staticClass: "u-right-margin--3xs",
                              attrs: { name: "pin", width: "20", height: "20" },
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text || item.value) +
                                "\n                    "
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.phone
            ? [
                _vm._l(_vm.phone, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: "phone-" + index,
                        staticClass: "communication-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "communication-item__title" },
                          [
                            index === 0
                              ? _c("span", [_vm._v(_vm._s(_vm.text.phone))])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "z-link",
                          {
                            staticClass: "communication-item__link",
                            attrs: {
                              href: "tel:" + item.value,
                              icon: "phone",
                              "icon-width": "20",
                              "icon-height": "20",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text || item.value) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.fax
            ? [
                _vm._l(_vm.fax, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: "fax-" + index,
                        staticClass: "communication-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "communication-item__title" },
                          [
                            index === 0
                              ? _c("span", [_vm._v(_vm._s(_vm.text.fax))])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "z-link",
                          {
                            staticClass: "communication-item__link",
                            attrs: {
                              href: "fax:" + item.value,
                              icon: "printer",
                              "icon-width": "20",
                              "icon-height": "20",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text || item.value) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.email
            ? [
                _vm._l(_vm.email, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: "email-" + index,
                        staticClass: "communication-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "communication-item__title" },
                          [
                            index === 0
                              ? _c("span", [_vm._v(_vm._s(_vm.text.email))])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "z-link",
                          {
                            staticClass: "communication-item__link",
                            attrs: {
                              href: "mailto:" + item.value,
                              inline: false,
                              icon: "mail",
                              "icon-width": "20",
                              "icon-height": "20",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text || item.value) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.site
            ? [
                _vm._l(_vm.site, function (item, index) {
                  return [
                    _c(
                      "div",
                      {
                        key: "site-" + index,
                        staticClass: "communication-item",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "communication-item__title" },
                          [
                            index === 0
                              ? _c("span", [_vm._v(_vm._s(_vm.text.site))])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "z-link",
                          {
                            staticClass: "communication-item__link",
                            attrs: {
                              href: "" + item.value,
                              icon: "external",
                              "icon-width": "20",
                              "icon-height": "20",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text || item.value) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "z-contact-card__content" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }